import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@jsverse/transloco';
import { CalloutService } from '@rma/generic/ui/callout';
import { LoadingIndicatorDirective } from '@rma/generic/ui/loading-indicator';

@Component({
  selector: 'rma-results-paging',
  imports: [LoadingIndicatorDirective, MatButtonModule, TranslocoModule],
  templateUrl: './paging.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultsPagingComponent implements OnChanges {
  @Input()
  saving: boolean | null = false;

  @Input()
  saved: number | null | undefined;

  @Input()
  savedMessage = '';

  @Input()
  canShowMore: boolean | null = false;

  @Output()
  save = new EventEmitter<void>();

  @Output()
  showMore = new EventEmitter<void>();

  private readonly messageService = inject(CalloutService);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['saved'] && this.saved) {
      this.messageService.getCalloutComponent(
        {
          callout: {
            message: this.savedMessage,
            calloutType: 'success',
            duration: 2000,
          },
          overlay: {
            disposeOnNavigation: true,
            hasBackdrop: true,
          },
        },
        null,
      );
    }
  }
}
